import React, {useEffect, useState} from 'react';
import {useLinkTo} from '@react-navigation/native';
import {Button, Container, Nav, Navbar, NavDropdown} from 'react-bootstrap';
import {FaHeadset} from 'react-icons/fa';
import {Image, StyleSheet, Platform, View, Text} from 'react-native';
import {GetNetworkProvider} from '../network/NetworkProvider';
import Emitter from './Emitter';
import {clearAll, getAccessToken} from '../database/DataBase';

export default function HomeHeader(props) {
  
  const [isSignedIn, setIsSignedIn] = useState(false);

  const context = GetNetworkProvider();
  const linkTo = useLinkTo();
  const name = context.profileInfo
    ? context.profileInfo.data
      ? context.profileInfo.data.profile.name
        ? context.profileInfo.data.profile.name
        : 'Loading...'
      : 'Loading...'
    : 'Loading...';
  const Id = context.profileInfo
    ? context.profileInfo.data
      ? context.profileInfo.data.profile.customer_id
        ? context.profileInfo.data.profile.customer_id
        : 'Loading...'
      : 'Loading...'
    : 'Loading...';
  const UserNameId = name.toUpperCase();
  
  useEffect(() => {
    getAccessToken()
    .then((data) => {
      if (data != null) {
        setIsSignedIn(true);
      }
    })
    .catch((e) => {
      console.log('error', e);
    });
  }, []);
  
  const onCRMPress = () => {
    linkTo('/customers/crm');
  };

  const getInitials = () => {
    const words = name.split(" ");
    return words.map((word) => {
      if(word.length > 0) return word.charAt(0);
      return "";
    }).join("").substring(0, 2);
  };

  return (
    // <Container >
      <Navbar
        collapseOnSelect
        expand="lg"
        sticky="top"
        style={{backgroundColor: 'black'}}
        variant="dark">
        <Navbar.Brand href="/customers/home">
          { 
            <Image
              style={styles.logoStyle}
              source={process.env.PUBLIC_URL + '/assets/ulkatvmini.png'}/>
          }
        </Navbar.Brand>
        <Navbar.Brand href="/customers/home">
          {/* <Image
            style={styles.logoStyle}
            source={process.env.PUBLIC_URL + '/assets/ulkatvmini.png'}></Image> */}
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto" activeKey={Platform.OS == "web" ?  window.location.pathname : props.navigation?.state?.routeName}>
            <Nav.Link href="/customers/home">Home</Nav.Link>
            <Nav.Link href="/customers/contact">Contact us</Nav.Link>
            <Nav.Link href="https://ulka.tv/about-us">About us</Nav.Link>
          </Nav>
          <Nav>
            {
              isSignedIn ? 
              (
                <NavDropdown title={getInitials()} style={{borderRadius: '50%',color:'#000',width: 45,height: 45, borderColor: 'transparent',
                  borderStyle: 'solid',
                  borderWidth: 0,
                  backgroundColor: 'red',
                  textAlign: 'center',
                  textAlignVertical: 'center',
                  justifyContent: 'center', fontSize: 15, padding: 5, marginRight: 10 }} id="collasible-nav-dropdown" drop={'left'}>
                  <NavDropdown.Header>{UserNameId}</NavDropdown.Header>
                  <NavDropdown.Divider/>
                  <NavDropdown.Item href="/customers/bouques">Manage packs</NavDropdown.Item>
                  <NavDropdown.Item href="/customers/profile">Profile</NavDropdown.Item>
                  <NavDropdown.Item href="/customers/transactions">
                    Transactions
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/customers/crm">Get Support</NavDropdown.Item>
                  <NavDropdown.Item href="/customers/contact">Contact us</NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item
                    href="#action/3.4"
                    onClick={() => {
                      Emitter.emit('login', false);
                      clearAll();
                    }}>
                    Log out
                  </NavDropdown.Item>
                </NavDropdown>
              )
              : <></>
            }
          </Nav>
          <Button onClick={onCRMPress} style={{backgroundColor: '#e10808', marginRight: 20 }} variant="danger">
            {' '}
            <FaHeadset /> Get Support
          </Button>
        </Navbar.Collapse>
      </Navbar>
    // </Container>
  );
}

const styles = StyleSheet.create({
  headerStyle: {
    borderBottomWidth: 0,
    height: 50,
  },
  logoStyle: {
    height: 38,
    width: 160,
  },
  username: {
    borderRadius: '50%',
    color:'#fff',
    width: 45,
    height: 45,
    borderColor: 'transparent',
    borderStyle: 'solid',
    borderWidth: 0,
    backgroundColor: 'red',
    textAlign: 'center',
    textAlignVertical: 'center',
    justifyContent: 'center',
  },
  usernameAbbr: {
    color: '#fff',
    fontSize: 18,
  }
});
